import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { Loader } from './Loader';
import { useAuth } from '../hooks';

export const PublicRoute = ({ children }) => {
  const { loading, isAuthenticated, user } = useAuth();

  if (loading) return <Loader loading />;

  if (isAuthenticated) {
    return (
      <Navigate
        to={'/tasks'}
        state={{
          affiliate: user.affiliate,
          userId: user.id,
          userEmail: user.email,
        }}
        replace
      />
    );
  }
  return children ? children : <Outlet />;
};
